import { createReducer, on } from '@ngrx/store';
import * as actions from '../actions/filtered-transactions.actions';
import { IFilteredTransactionsResponse } from '../models/filtered-transactions.model';

export const filteredTransactionsFeatureKey = 'filteredTransactions';

export interface FilteredTransactionsState {
  loading: boolean;
  error: any;
  data: IFilteredTransactionsResponse | null;
}

export const initialState: FilteredTransactionsState = {
  loading: false,
  error: null,
  data: null
};

export const reducer = createReducer(
  initialState,
  on(actions.loadFilteredTransactions, state => ({
    ...state,
    loading: true,
    error: null
  })),
  on(actions.loadFilteredTransactionsSuccess, (state, { response }) => ({
    ...state,
    loading: false,
    data: response,
    error: null
  })),
  on(actions.loadFilteredTransactionsFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error
  }))
);

export const getFilteredTransactions = (state: FilteredTransactionsState) => state.data;